import { CustomIconComponentProps } from "@ant-design/icons/es/components/Icon";
import Icon from "@ant-design/icons";

export default function ElectricityIcon(props: Partial<CustomIconComponentProps>) {
  return (
    <Icon
      {...props}
      component={() => (
        <svg
          width={props.width || 18}
          height={props.height || 20}
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.8772 6.42109H11.7139L16.3568 0.554688C16.4529 0.430469 16.3662 0.25 16.2092 0.25H7.2209C7.15528 0.25 7.09199 0.285156 7.05918 0.34375L0.986526 10.832C0.913869 10.9563 1.00293 11.1133 1.14824 11.1133H5.23574L3.14043 19.4945C3.0959 19.6773 3.31621 19.8062 3.45215 19.675L17.0061 6.74219C17.1279 6.62734 17.0459 6.42109 16.8772 6.42109ZM5.86621 15.168L7.27949 9.51953H3.59043L8.03418 1.84609H13.2982L8.41621 8.01719H13.3615L5.86621 15.168Z"
            fill="#FADB14"
          />
        </svg>
      )}
    />
  );
}
